import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Spinner, Alert, Button } from 'react-bootstrap';
import api from '../api/api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'expired'
  const token = searchParams.get('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setStatus('expired'); return; }
    
    api.get(`/public/verify-email?token=${token}`)
      .then(res => setStatus('success'))
      .catch(() => setStatus('expired'));
  }, [token]);

  if (status === 'loading') return <Container className="text-center py-5"><Spinner animation="border" aria-hidden="true" /></Container>;

  if (status === 'expired') return (
    <Container className="py-5 text-center">
      <Alert variant="danger" className="p-5 border-0 shadow" role="alert">
        <h3 className="fw-bold">Link Expired or Invalid ❌</h3>
        <p>This verification link has expired (24h limit) or has already been used.</p>
        <Button variant="outline-danger" onClick={() => navigate('/register')}>Start New Registration</Button>
      </Alert>
    </Container>
  );

  return (
    <Container className="py-5 text-center">
      <Alert variant="success" className="p-5 border-0 shadow" role="status">
        <h3 className="fw-bold">Email Verified Successfully! 🚀</h3>
        <p>Your institutional account is now active with 100 startup credits.</p>
        <p>We've sent your <b>Administrator Credentials</b> to your inbox.</p>
        <Button variant="primary" onClick={() => navigate('/login')}>Go to Login</Button>
      </Alert>
    </Container>
  );
};

export default VerifyEmailPage;
